var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-chat-form-component",
      class: [
        _vm.type,
        `section-${_vm.section}`,
        { mine: _vm.isMine },
        { fix: _vm.isFixed },
        { whisper: _vm.isWhisper },
        { staff: _vm.isWhisperStaff },
      ],
      on: { click: _vm.switchChatTypeToWhisper },
    },
    [
      _c(
        "div",
        { staticClass: "room-chat-form" },
        [
          !_vm.isMyChat && !_vm.isSystemNoti
            ? _c("GrmAvatar", {
                attrs: { icon: _vm.profileIcon, src: _vm.avatarSrc },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "room-chat" },
            [
              !_vm.isMyChat && !_vm.isSystemNoti
                ? _c(
                    "div",
                    { staticClass: "room-chat-info" },
                    [
                      _vm.isOpener(_vm.item.userId) && !_vm.item.isFile
                        ? _c("GrmIcon", {
                            staticClass: "!w-4 mr-1",
                            attrs: { icon: "opener" },
                          })
                        : _vm._e(),
                      _c("p", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.item.nickname,
                            expression: "item.nickname",
                          },
                        ],
                        staticClass: "room-chat-user-nickname sender",
                        domProps: { innerHTML: _vm._s(_vm.item.nickname) },
                      }),
                      _c("p", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.item.receiveUser,
                            expression: "item.receiveUser",
                          },
                        ],
                        staticClass: "room-chat-user-nickname receiver",
                        domProps: { innerHTML: _vm._s(_vm.item.receiveUser) },
                      }),
                      _vm.item.receiveDate
                        ? _c("p", { staticClass: "room-chat-time" }, [
                            _vm._v(_vm._s(_vm.item.receiveDate)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isMyChat
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "room-chat-message-wrapper",
                        staticStyle: { opacity: "0.6" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "room-chat-message-loading" },
                          [
                            _c(
                              "p",
                              { staticClass: "room-chat-message-loading-text" },
                              [_vm._v(_vm._s(_vm.$t("chat.form.sending")))]
                            ),
                          ]
                        ),
                        _c("pre", {
                          staticClass: "room-chat-message me",
                          domProps: { innerHTML: _vm._s(_vm.item.myChats) },
                        }),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm.item.isFile
                ? [
                    _c("div", { staticClass: "room-chat-file-info" }, [
                      _vm.item.title
                        ? _c(
                            "p",
                            {
                              staticClass: "room-chat-file-name",
                              class: { "line-through": _vm.item.del },
                            },
                            [_vm._v(_vm._s(_vm.item.title))]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "room-chat-file-detail-info" }, [
                        _c("p", { staticClass: "room-chat-file-size" }, [
                          _vm._v(_vm._s(_vm.item.filesize)),
                        ]),
                        _vm.item.duration
                          ? _c("p", { staticClass: "room-chat-file-time" }, [
                              _vm._v(_vm._s(_vm.item.duration)),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.item.expireDate
                        ? _c("p", { staticClass: "room-chat-file-period" }, [
                            _vm._v(
                              _vm._s(_vm.$t("chat.form.expireDate")) +
                                " : ~ " +
                                _vm._s(_vm.item.expireDate)
                            ),
                          ])
                        : _vm._e(),
                      _vm.isDownloading || _vm.isUploding
                        ? _c(
                            "div",
                            { staticClass: "room-chat-file-progress" },
                            [
                              _c(
                                "div",
                                { staticClass: "room-chat-file-percent" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "room-chat-file-percent-number",
                                    },
                                    [_vm._v(_vm._s(_vm.item.progress))]
                                  ),
                                  _vm._v("% "),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "room-chat-file-progress-bar-wrapper",
                                },
                                [
                                  _c("div", {
                                    staticClass: "room-chat-file-progress-bar",
                                    style: _vm.progressBarStyle,
                                  }),
                                ]
                              ),
                            ]
                          )
                        : !_vm.hideDownload || _vm.isPreparing
                        ? _c("button", {
                            staticClass: "room-chat-file-download-button",
                            class: { preparing: _vm.isPreparing },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("onClickDownload")
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "room-chat-message-wrapper" }, [
                      _c("div", { staticClass: "relative" }, [
                        _c("pre", {
                          staticClass: "room-chat-message",
                          class: [_vm.item.type === "stt" && "stt"],
                          domProps: { innerHTML: _vm._s(_vm.content) },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("onChangeNoticeSection")
                            },
                          },
                        }),
                      ]),
                      _vm.isSystemNoti
                        ? _c("div", { staticClass: "room-chat-noti-time" }, [
                            _vm._v(_vm._s(_vm.item.date)),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "relative" }, [
                        _vm.item.type === "stt" && _vm.item.translatedText
                          ? _c(
                              "pre",
                              { staticClass: "room-chat-message translation" },
                              [_vm._v(_vm._s(_vm.item.translatedText))]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ],
              _vm.hasEmceeRole() &&
              !_vm.isMyChat &&
              !_vm.isWhisper &&
              _vm.chatMoreList.length
                ? _c(
                    "div",
                    { staticClass: "room-chat-more" },
                    [
                      _c("button", {
                        staticClass: "room-chat-more-button",
                        on: { click: _vm.onToggleOpenChatMoreList },
                      }),
                      _c("GrmMenu", {
                        attrs: {
                          "text-align": "left",
                          list: _vm.chatMoreList,
                          open: _vm.isOpenChatMoreList,
                        },
                        on: {
                          "update:open": function ($event) {
                            _vm.isOpenChatMoreList = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }